module.exports = __webpack_public_path__ + "img/ICON-TEAM-WORK.4ca06d3e.png";